import { configStore } from '~stores/config';
export default async (router, toState) => {
    if (configStore.hideHiddenDeals) {
        router.cancel();
        router.navigate('home.view');
        return null;
    }
    return toState;
};
